import React from 'react'

export const PacelineLoaderIcon: React.FC = () => {
  return (
    <img
      src={require('../../assets/PacelineLoader.gif')}
      height="100 px"
      width="200 px"
      alt="...loading"
    />
  )
}
